import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import styles from "./leaselist.module.css";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useHistory } from "react-router-dom";
import { ChevronDown, ChevronUp, Code, User } from "react-feather";

const LeaseList = ({ allData, filterData }) => {
  const redirect = useHistory();
  const [filterredData, setFilterredData] = useState([]);
  const [sortItem, setSortItem] = useState("");
  const [sortOrder, setSortOrder] = useState("");

  const changeSortOrder = (type) => {
    if (type === sortItem) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
      } else {
        setSortOrder("asc");
      }
    } else {
      setSortOrder("asc");
    }
    setSortItem(type);
  };

  useEffect(() => {
    let filterredDataTemp = allData;

    if (filterData?.searchKey !== "") {
      let inputVal = filterData?.searchKey;
      inputVal = inputVal.toLowerCase();
      filterredDataTemp = filterredDataTemp.filter(
        (item) =>
          item?.tenant_id &&
          (item?.tenant_name.toLowerCase().includes(inputVal) ||
            item?.property_name.toLowerCase().includes(inputVal) ||
            item?.apt_no.toLowerCase().includes(inputVal) ||
            item?.formatted_amount.toLowerCase().includes(inputVal) ||
            item?.formatted_rent.toLowerCase().includes(inputVal))
      );
    }

    if (filterData?.property !== "" && filterData?.property !== "all") {
      filterredDataTemp = filterredDataTemp.filter(
        (i) => i.property_id === filterData.property
      );
    }

    if (filterData?.apartment !== "" && filterData?.apartment !== "all") {
      filterredDataTemp = filterredDataTemp.filter(
        (i) => i.apt_id === filterData.apartment
      );
    }

    if (filterData?.status !== "" && filterData?.status !== "all") {
      filterredDataTemp = filterredDataTemp.filter(
        (i) =>
          i?.tenant_id &&
          i?.lease_status.indexOf(parseInt(filterData.status)) > -1
      );
    }

    setFilterredData(filterredDataTemp);
  }, [allData, filterData]);

  const goToDetails = (item) => {
    redirect.push("/leases/details/" + item.tenant_id);
  };

  return (
    <div className={`${styles.IncomeListUnderSec}`}>
      <div className={`${styles.ListCardDivSec}`}>
        {filterredData.map((item) => {
          return (
            <div className={`${styles.CardDivList}`}>
              <div
                className={`${styles.FirstSec} ${styles.ProfileImg}`}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (item?.tenant_id) {
                    redirect.push("/people/tenants/details/" + item.tenant_id);
                  }
                }}
              >
                {item?.tenant_id ? (
                  <>
                    {item?.tenant_image !== "" ? (
                      <img src={item?.tenant_image} alt="" />
                    ) : (
                      <div className={`${styles.ProNameIMG}`}>
                        <p>{item?.tenant_initial}</p>
                      </div>
                    )}
                  </>
                ) : (
                  <div className={`${styles.ProNameIMG}`}>
                    <User />
                  </div>
                )}
                <div>
                  {item?.tenant_id ? <p className={`${styles.Name} ${styles.Hover}`}>
                    {item?.tenant_name}
                  </p> :
                    <p className={`${styles.Name}`}>
                      Vacant
                    </p>}
                  <p
                    className={`${styles.Name} ${styles.Hover}`}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      redirect.push("/properties/details/" + item?.property_id);
                    }}
                  >
                    {item.property_name} - {item.apt_no}
                  </p>
                </div>
              </div>
              <div className={`${styles.SecondSec}`}>
                <p className={`${styles.Name}`}>
                  Rent: <span>${item.formatted_rent}</span>
                </p>
                <p className={`${styles.Name}`}>
                  Sec. Deposit:{" "}
                  <span>
                    {item?.tenant_id ? "$" + item.formatted_amount : "-"}
                  </span>
                </p>
              </div>
              <div className={`${styles.ThirdSec}`}>
                <div className={`${styles.StatusBadgeSecMobile}`}>
                  {item?.tenant_id ? (
                    <>
                      {item.lease_status.indexOf(1) > -1 &&
                        item.lease_status.indexOf(6) === -1 && (
                          <span
                            className={`${styles.StatusBadge} ${styles.Confirm}`}
                          >
                            Verified
                          </span>
                        )}
                      {item.lease_status.indexOf(0) > -1 &&
                        item.lease_status.indexOf(6) === -1 && (
                          <span
                            className={`${styles.StatusBadge} ${styles.NotVerified}`}
                          >
                            Not Verified
                          </span>
                        )}
                      {item.lease_status.indexOf(4) > -1 &&
                        item.lease_status.indexOf(6) === -1 && (
                          <span
                            className={`${styles.StatusBadge} ${styles.Confirm}`}
                          >
                            Signed
                          </span>
                        )}
                      {item.lease_status.indexOf(3) > -1 &&
                        item.lease_status.indexOf(6) === -1 && (
                          <span
                            className={`${styles.StatusBadge} ${styles.Confirm}`}
                          >
                            Tenant Signed
                          </span>
                        )}
                      {item.lease_status.indexOf(2) > -1 &&
                        item.lease_status.indexOf(6) === -1 && (
                          <span
                            className={`${styles.StatusBadge} ${styles.NotVerified}`}
                          >
                            Not Signed
                          </span>
                        )}
                      {item.lease_status.indexOf(5) > -1 && (
                        <span
                          className={`${styles.StatusBadge} ${styles.Pending}`}
                        >
                          Expire Soon
                        </span>
                      )}
                      {item.lease_status.indexOf(6) > -1 && (
                        <span
                          className={`${styles.StatusBadge} ${styles.Failed}`}
                        >
                          Expired
                        </span>
                      )}
                    </>
                  ) : (
                    "-"
                  )}
                </div>
                <p className={`${styles.Name}`}>
                  <span>
                    {item?.tenant_id
                      ? dayjs(item.start_date).format("L") +
                      " - " +
                      dayjs(item.end_date).format("L")
                      : "-"}
                  </span>
                </p>
              </div>
            </div>
          );
        })}
      </div>

      {filterredData?.length > 0 && (
        <TableContainer className={`${styles.TableDiv} CustomTableDiv`}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  className={`${styles.TableHead}`}
                  style={{ width: 300 }}
                  onClick={(e) => changeSortOrder("tenant_name")}
                >
                  Tenant
                  {sortItem === "tenant_name" && sortOrder === "asc" && (
                    <ChevronDown />
                  )}
                  {sortItem === "tenant_name" && sortOrder === "desc" && (
                    <ChevronUp />
                  )}
                  {sortItem !== "tenant_name" && (
                    <Code className={`${styles.Normal}`} />
                  )}
                </TableCell>
                <TableCell
                  className={`${styles.TableHead}`}
                  style={{ width: 150 }}
                  onClick={(e) => changeSortOrder("rent")}
                >
                  Rent
                  {sortItem === "rent" && sortOrder === "asc" && (
                    <ChevronDown />
                  )}
                  {sortItem === "rent" && sortOrder === "desc" && <ChevronUp />}
                  {sortItem !== "rent" && (
                    <Code className={`${styles.Normal}`} />
                  )}
                </TableCell>
                <TableCell
                  className={`${styles.TableHead}`}
                  style={{ width: 150 }}
                  onClick={(e) => changeSortOrder("security_amount")}
                >
                  Sec. Deposit
                  {sortItem === "security_amount" && sortOrder === "asc" && (
                    <ChevronDown />
                  )}
                  {sortItem === "security_amount" && sortOrder === "desc" && (
                    <ChevronUp />
                  )}
                  {sortItem !== "security_amount" && (
                    <Code className={`${styles.Normal}`} />
                  )}
                </TableCell>
                <TableCell
                  className={`${styles.TableHead}`}
                  style={{ width: 300 }}
                  onClick={(e) => changeSortOrder("lease_term")}
                >
                  Lease Term
                  {sortItem === "lease_term" && sortOrder === "asc" && (
                    <ChevronDown />
                  )}
                  {sortItem === "lease_term" && sortOrder === "desc" && (
                    <ChevronUp />
                  )}
                  {sortItem !== "lease_term" && (
                    <Code className={`${styles.Normal}`} />
                  )}
                </TableCell>
                <TableCell
                  className={`${styles.TableHead}`}
                  style={{ width: 200 }}
                  onClick={(e) => changeSortOrder("property_name")}
                >
                  Property
                  {sortItem === "property_name" && sortOrder === "asc" && (
                    <ChevronDown />
                  )}
                  {sortItem === "property_name" && sortOrder === "desc" && (
                    <ChevronUp />
                  )}
                  {sortItem !== "property_name" && (
                    <Code className={`${styles.Normal}`} />
                  )}
                </TableCell>
                <TableCell
                  className={`${styles.TableHead}`}
                  style={{ width: 150 }}
                  onClick={(e) => changeSortOrder("apt_no")}
                >
                  Unit
                  {sortItem === "apt_no" && sortOrder === "asc" && (
                    <ChevronDown />
                  )}
                  {sortItem === "apt_no" && sortOrder === "desc" && (
                    <ChevronUp />
                  )}
                  {sortItem !== "apt_no" && (
                    <Code className={`${styles.Normal}`} />
                  )}
                </TableCell>
                <TableCell
                  className={`${styles.TableHead}`}
                  style={{ width: 200 }}
                >
                  Status
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filterredData
                .sort((a, b) => {
                  if (sortItem === "tenant_name") {
                    return sortOrder === "desc"
                      ? !a.tenant_name?.trim()
                        ? 1
                        : !b.tenant_name?.trim()
                          ? -1
                          : a.tenant_name.toLowerCase() <
                            b.tenant_name.toLowerCase()
                            ? 1
                            : -1
                      : !a.tenant_name?.trim()
                        ? 1
                        : !b.tenant_name?.trim()
                          ? -1
                          : a.tenant_name.toLowerCase() >
                            b.tenant_name.toLowerCase()
                            ? 1
                            : -1;
                  } else if (sortItem === "rent") {
                    if (sortOrder === "desc") {
                      return a?.rent < b?.rent ? 1 : -1;
                    } else {
                      return a?.rent > b?.rent ? 1 : -1;
                    }
                  } else if (sortItem === "security_amount") {
                    if (a?.security_amount === null) return 1;
                    if (b?.security_amount === null) return -1;
                    if (sortOrder === "desc") {
                      return b?.security_amount - a?.security_amount;
                    } else {
                      return a?.security_amount - b?.security_amount;
                    }
                  } else if (sortItem === "lease_term") {
                    return sortOrder === "desc"
                      ? typeof a?.end_date === "undefined"
                        ? 1
                        : typeof b?.end_date === "undefined"
                          ? -1
                          : new Date(a?.end_date) < new Date(b?.end_date)
                            ? 1
                            : -1
                      : typeof a?.end_date === "undefined"
                        ? 1
                        : typeof b?.end_date === "undefined"
                          ? -1
                          : new Date(a?.end_date) > new Date(b?.end_date)
                            ? 1
                            : -1;
                  } else if (sortItem === "property_name") {
                    if (sortOrder === "desc") {
                      return a.property_name < b.property_name ? 1 : -1;
                    } else {
                      return a.property_name > b.property_name ? 1 : -1;
                    }
                  } else if (sortItem === "apt_no") {
                    if (sortOrder === "desc") {
                      return a.apt_no < b.apt_no ? 1 : -1;
                    } else {
                      return a.apt_no > b.apt_no ? 1 : -1;
                    }
                  } else {
                    return (b?.list_id ?? 0) - (a?.list_id ?? 0);
                  }
                })
                .map((item) => {
                  return (
                    <TableRow onClick={(e) => goToDetails(item)}>
                      <TableCell
                        className={`${styles.TableBodyText} ${styles.ProfileImg} ${styles.Hover}`}
                      >
                        {item?.tenant_id ? (
                          <>
                            <div className={`${styles.TenantInside}`}>
                              {item?.tenant_image !== "" ? (
                                <img src={item?.tenant_image} alt="" />
                              ) : (
                                <div className={`${styles.ProNameIMG}`}>
                                  <p>{item?.tenant_initial}</p>
                                </div>
                              )}
                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  if (item?.tenant_id) {
                                    redirect.push(
                                      "/people/tenants/details/" + item.tenant_id
                                    );
                                  }
                                }}
                              >{item?.tenant_name}</span>
                            </div>
                          </>
                        ) : (
                          <div className={`${styles.TenantInside}`}>
                            <div className={`${styles.ProNameIMG}`}>
                              <User />
                            </div>{" "}
                            Vacant
                          </div>
                        )}
                      </TableCell>
                      <TableCell className={`${styles.TableBodyText}`}>
                        ${item.formatted_rent}
                      </TableCell>
                      <TableCell className={`${styles.TableBodyText}`}>
                        {item?.tenant_id ? "$" + item.formatted_amount : "-"}
                      </TableCell>
                      <TableCell className={`${styles.TableBodyText}`}>
                        {item?.tenant_id
                          ? dayjs(item.start_date).format("L") +
                          " - " +
                          dayjs(item.end_date).format("L")
                          : "-"}
                      </TableCell>
                      <TableCell
                        className={`${styles.TableBodyText} ${styles.Hover}`}
                      >
                        <span
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            redirect.push(
                              "/properties/details/" + item?.property_id
                            );
                          }}
                        >{item.property_name}</span>
                      </TableCell>
                      <TableCell className={`${styles.TableBodyText}`}>
                        {item.apt_no}
                      </TableCell>
                      <TableCell>
                        {item?.tenant_id ? (
                          <>
                            {item.lease_status.indexOf(1) > -1 &&
                              item.lease_status.indexOf(6) === -1 && (
                                <span
                                  className={`${styles.StatusBadge} ${styles.Confirm}`}
                                >
                                  Verified
                                </span>
                              )}
                            {item.lease_status.indexOf(0) > -1 &&
                              item.lease_status.indexOf(6) === -1 && (
                                <span
                                  className={`${styles.StatusBadge} ${styles.NotVerified}`}
                                >
                                  Not Verified
                                </span>
                              )}
                            {item.lease_status.indexOf(4) > -1 &&
                              item.lease_status.indexOf(6) === -1 && (
                                <span
                                  className={`${styles.StatusBadge} ${styles.Confirm}`}
                                >
                                  Signed
                                </span>
                              )}
                            {item.lease_status.indexOf(3) > -1 &&
                              item.lease_status.indexOf(6) === -1 && (
                                <span
                                  className={`${styles.StatusBadge} ${styles.Confirm}`}
                                >
                                  Tenant Signed
                                </span>
                              )}
                            {item.lease_status.indexOf(2) > -1 &&
                              item.lease_status.indexOf(6) === -1 && (
                                <span
                                  className={`${styles.StatusBadge} ${styles.NotVerified}`}
                                >
                                  Not Signed
                                </span>
                              )}
                            {item.lease_status.indexOf(5) > -1 && (
                              <span
                                className={`${styles.StatusBadge} ${styles.Pending}`}
                              >
                                Expire Soon
                              </span>
                            )}
                            {item.lease_status.indexOf(6) > -1 && (
                              <span
                                className={`${styles.StatusBadge} ${styles.Failed}`}
                              >
                                Expired
                              </span>
                            )}
                            {item.lease_status.indexOf(7) > -1 && (
                              <span
                                className={`${styles.StatusBadge} ${styles.Archived}`}
                              >
                                Archived
                              </span>
                            )}
                          </>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {filterredData.length === 0 && (
        <div className={`${styles.NoDataMain}`}>
          <div className={`${styles.NoDataIMG}`}>
            <img src="/static/img/no-lease.png" alt="No Data" />
          </div>
          <p className={`${styles.NoDataText}`}>Unfortunately!</p>
          <p className={`${styles.NoDataTextSub}`}>
            we couldn't find any leases at this time.
          </p>
        </div>
      )}
    </div>
  );
};

export default LeaseList;
